export default "__VITE_ASSET__CBs0I2oa__"